var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaneNe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46199 14.4211L3.3655 15.5175L8.48246 20.6345L9.57895 19.538L9.21345 16.9795L13.2339 12.9591L17.6199 21L19.0819 19.538L16.5234 9.66959L20.5439 5.64913C20.8484 5.34454 21.0005 4.97905 21 4.55263C21.0005 4.12622 20.8484 3.76072 20.5439 3.45614C20.2393 3.15156 19.8738 2.99951 19.4474 3C19.021 2.99951 18.6555 3.15156 18.3509 3.45614L14.3304 7.47661L4.46199 4.91813L3 6.38012L11.0409 10.7661L7.02047 14.7866L4.46199 14.4211Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneNe);
export default __webpack_public_path__ + "static/media/plane_ne.7e849a15e3abc716ad875239ca1fdace.svg";
export { ForwardRef as ReactComponent };